import React from 'react'
import { SigurModalSearch } from "../lib/SigurModalSearch";

/** Модальное окно «Поиск» без кнопки «Сохранить в отбор». */
export class RequestsModalSearch extends SigurModalSearch {
  renderSaveSearch() {
    return null
  }
}
